export default "__VITE_ASSET__BDndLkiN__"